import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";
export var SOYOProcessing = function SOYOProcessing() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "M5A5R8",
    defaultMessage: [{
      "type": 0,
      "value": "Pour mettre à jour les informations de suivi d'une commande qui n'a pas encore été expédiée, procédez comme suit :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JUmURU",
    defaultMessage: [{
      "type": 0,
      "value": "Rendez-vous dans l'onglet Commandes, puis sélectionnez la commande que vous souhaitez modifier."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hsC0PT",
    defaultMessage: [{
      "type": 0,
      "value": "Sur la page des détails de la commande, choisissez l'option Modifier à côté des détails de l'expédition."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "If87ZM",
    defaultMessage: [{
      "type": 0,
      "value": "Mettez à jour les informations d'expédition requises comme le transporteur, le numéro de suivi et la date d'expédition prévue."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "noKs1A",
    defaultMessage: [{
      "type": 0,
      "value": "Nous vous recommandons également d'informer votre commerçant sur "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " des modifications apportées aux détails de l'expédition afin d'éviter toute confusion."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};